import { Fractions } from '../types';

export const createFractionsFromIds = (ids: number[], fractionEnabled: number): Fractions =>
  Object.fromEntries(ids.map((id) => [id, fractionEnabled]));
